<template>
  <div
    v-if="!Array.isArray(dossier[column.field])"
    class="text-xs text-gray-700 dark:text-white"
  >
    <div v-if="dossier[column.field] === '#######'">
      {{ $t('attributes.undefined') }}
    </div>
    <div v-else v-html="dossier[column.field]"></div>
  </div>
  <div
    v-else
    class="flex flex-col gap-0.5 px-2 text-xs text-gray-700 dark:text-white"
  >
    <template v-for="field in dossier[column.field]" :key="field.value">
      <div
        v-if="field.value !== '#######'"
        class="flex flex-row justify-center"
      >
        <FontAwesomeIcon
          v-if="field.icon"
          :icon="['fal', field.icon]"
          class="mr-1.5 mt-0.5"
        />
        <span v-if="field.icon">{{ field.value }}</span>
      </div>
    </template>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DateComponent',
  components: { FontAwesomeIcon },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    }
  }
}
</script>
